import { performRequest } from "./api-handler";
import { URLS } from "../utility/urls";

export default () => {
  const {
    GET_PARENT_MODULES_DETAILS,
    ADD_PARENT_MODULES_DETAILS,
    UPDATE_PARENT_MODULES_DETAILS,
    DELETE_PARENT_MODULES_DETAILS,
  } = URLS;

  return {
    getParentModulesDetails: (body = {}, method = "get") =>
      performRequest(method ? method : "get", GET_PARENT_MODULES_DETAILS, body),
    addParentModulesDetails: (body = {}, method = "post") =>
      performRequest(method ? method : "post", ADD_PARENT_MODULES_DETAILS, body),
    updateParentModulesDetails: (body = {}, method = "put") =>
      performRequest(method ? method : "put", UPDATE_PARENT_MODULES_DETAILS, body),
    deleteParentModulesDetails: (body = {}, method = "delete") =>
      performRequest(method ? method : "delete", DELETE_PARENT_MODULES_DETAILS, body),
  };
};

